import { Route, Switch, BrowserRouter } from "react-router-dom";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Home from "./component/home";
import About from "./component/about";
import Resume from "./component/resume";
import Services from "./component/services";
import Contact from "./component/contact";
import Portfolio from "./component/portfolio";

export const newTab = (address) => {
  window.open(address);
};
function App() {
  return (
    <div className="App">
      {/* <Router> */}
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/resume" component={Resume} />
          <Route exact path="/services" component={Services} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/portfolio" component={Portfolio} />
          <Route path="*" component={() => <h2>Page Not Found</h2>} />

          {/* External Routes */}
          <Route
            exact
            path="/facebook"
            render={() => (window.location = "https://facebook.com")}
          />
        </Switch>
      </BrowserRouter>
      {/* </Router> */}
    </div>
  );
}

export default App;
